import useGlobal from "../../../useGlobal";
import store from "../../../store";
import { giftDedicationPackagingId } from "../../../../config";

export default function useProductService() {
  const { getData } = useGlobal();

  const attributeWithPackagingText = giftDedicationPackagingId;

  function getProductServicePrice(product) {
    let price = 0;

    if (product.services.length) {
      product.services.map((service) => {
        price += Number(service.price);
      });
    }

    return price;
  }

  function getActiveAttributeValue(product) {
    return product.attribute_values.packaging || {};
  }

  function getProductServiceData(service) {
    const packageTheme = service.attribute_values.length
      ? service.attribute_values[0]
      : null;

    return {
      id: service.id,
      slug: service.slug,
      name: service.name,
      packaging_theme: packageTheme,
    };
  }

  function toggleService(event, product, service) {
    const uncheckedService = !event.target.checked;

    if (uncheckedService) {
      product.services = product.services.filter(
        (productService) => productService.id != service.id
      );
    } else {
      product.services.push(getProductServiceData(service));
    }
  }

  function setAttributeValue(product, attribute, attributeValue) {
    updateProductAttributeValue(product, attribute, attributeValue);
  }

  async function updateProductAttributeValue(
    product,
    attribute,
    attributeValue
  ) {
    const commitMethod = "loader/SET_LOADER";

    // set new value
    if (product.attribute_values[attribute.slug] !== attributeValue) {
      store.commit(commitMethod, true);

      product.attribute_values[attribute.slug] = attributeValue;
      // hide and clear packaging text field
      if (attributeValue.id !== giftDedicationPackagingId) {
        product.attributes.packagingText = null;
      }

      // checking stock and getting variant id with price
      await calculateVariantPrice(product); // axios

      store.commit(commitMethod, false);
    }
  }

  // Actions
  async function calculateVariantPrice(product) {
    const dispatchMethod = "cart/CALCULATE_PRICE";

    await store.dispatch(dispatchMethod, product).then(({ data }) => {
      if (!data.error) {
        product.product_variant_id = data.product_variant.id;
        product.price = data.product_variant.price;
      }
    });
  }

  async function setProductServices() {
    const dispatchMethod = "productService/GET_PRODUCT_SERVICES";
    const commitMethod = "productService/SET_PRODUCT_SERVICES";

    await getData(dispatchMethod, commitMethod);
  }

  return {
    getProductServicePrice,
    setAttributeValue,
    toggleService,
    getActiveAttributeValue,
    setProductServices,
    attributeWithPackagingText,
  };
}
